import React from 'react';
import OutlinedTextField from '@routes/Common/OutlinedTextField';
import { Search } from '@material-ui/icons';
import useStyles from './useStyles';

interface Props {
  keyword: string;
  onChange: (value: string) => void;
}
const ConnectDriveSearchBar = ({ keyword, onChange }: Props) => {
  const classes = useStyles();

  return (
    <OutlinedTextField
      fullWidth
      className={classes['Connect-Drive-Search-root']}
      color="secondary"
      size="large"
      align="left"
      placeholder="파일이름으로 검색"
      InputProps={{
        startAdornment: <Search />
      }}
      onChange={(e) => onChange(e.currentTarget.value)}
    />
  );
};

export default ConnectDriveSearchBar;
